var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5492 14.7596L15.0281 14.7916L14.5492 14.7596ZM5.45045 14.7596L5.92938 14.7277L5.45045 14.7596ZM14.7209 4.96807L14.0702 14.7277L15.0281 14.7916L15.6787 5.03193L14.7209 4.96807ZM12.1545 16.52H7.84513V17.48H12.1545V16.52ZM5.92938 14.7277L5.27874 4.96807L4.32087 5.03193L4.97151 14.7916L5.92938 14.7277ZM7.84513 16.52C6.83432 16.52 5.99662 15.7363 5.92938 14.7277L4.97151 14.7916C5.07237 16.3044 6.32892 17.48 7.84513 17.48V16.52ZM14.0702 14.7277C14.003 15.7363 13.1653 16.52 12.1545 16.52V17.48C13.6707 17.48 14.9272 16.3044 15.0281 14.7916L14.0702 14.7277Z",
    fill: "#CC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 4.52C2.9351 4.52 2.7202 4.7349 2.7202 5C2.7202 5.2651 2.9351 5.48 3.2002 5.48L3.2002 4.52ZM16.8002 5.48C17.0653 5.48 17.2802 5.2651 17.2802 5C17.2802 4.7349 17.0653 4.52 16.8002 4.52L16.8002 5.48ZM3.2002 5.48L16.8002 5.48L16.8002 4.52L3.2002 4.52L3.2002 5.48Z",
    fill: "#CC0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60059 4.6V3.8C7.60059 3.35817 7.95876 3 8.40059 3H11.6006C12.0424 3 12.4006 3.35817 12.4006 3.8V4.6",
    stroke: "#CC0000",
    strokeWidth: 0.96
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60059 8.2002V13.4002M11.4006 8.2002V13.4002",
    stroke: "#CC0000",
    strokeWidth: 0.96
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.c341806a67c83f77e9fd59c51160dceb.svg";
export { ForwardRef as ReactComponent };